import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '@core/environment/environment.service';


@Injectable()
export class WizardRestService {

    private controllerUrl = this.environmentService.serverApiUrl + '/secured/wizard';

    constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    }

    getWizardContent(id: string): Observable<string> {
        return this.httpClient.get<string>(this.controllerUrl.concat('/content/').concat(id));
    }
}

